import { Link } from 'react-router';
import * as QRCode from 'qrcode.react';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { useI18nContext } from '@/i18n/i18n-react';

export interface CampaignTestNotificationDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  isMobile: boolean;
  appScheme: string;
  adminUserId: string;
  isSending: boolean;
  onSend: () => void;
}

export function CampaignTestNotificationDialog({
  open,
  onOpenChange,
  isMobile,
  appScheme,
  adminUserId,
  isSending,
  onSend,
}: CampaignTestNotificationDialogProps) {
  const { LL } = useI18nContext();
  const registerUrl = `${appScheme}://register-test-device?adminUserId=${adminUserId}`;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      {!isMobile ? (
        <DialogContent className="sm:max-w-md">
          <DialogHeader>
            <DialogTitle>{LL.createCampaign.testDialogTitle()}</DialogTitle>
            <DialogDescription>
              {LL.createCampaign.testDialogDescriptionQR()}
            </DialogDescription>
          </DialogHeader>
          <div className="flex flex-col items-center justify-center p-6">
            <div className="mb-4 rounded-lg border border-border p-4">
              <QRCode.QRCodeSVG
                value={registerUrl}
                size={200}
                bgColor="#ffffff"
                fgColor="#000000"
                level="H"
                includeMargin={true}
              />
            </div>
            <p className="mb-4 text-center text-sm text-muted-foreground">
              {LL.createCampaign.testDialogScanInstructions()}
            </p>
            <Button onClick={onSend} disabled={isSending}>
              {isSending
                ? LL.createCampaign.testDialogSending()
                : LL.createCampaign.testDialogSendButton()}
            </Button>
          </div>
        </DialogContent>
      ) : (
        <DialogContent className="sm:max-w-md">
          <DialogHeader>
            <DialogTitle>{LL.createCampaign.testDialogTitle()}</DialogTitle>
            <DialogDescription>
              {LL.createCampaign.testDialogDescriptionMobile()}
            </DialogDescription>
          </DialogHeader>
          <div className="flex flex-col items-center justify-center space-y-4 p-6">
            <Link to={registerUrl}>
              <Button>
                {LL.createCampaign.testDialogRegisterMobileButton()}
              </Button>
            </Link>
            <p className="mb-4 text-center text-sm text-muted-foreground">
              {LL.createCampaign.testDialogRegisterInstructionsMobile()}
            </p>
            <Button onClick={onSend} disabled={isSending}>
              {isSending
                ? LL.createCampaign.testDialogSending()
                : LL.createCampaign.testDialogSendButton()}
            </Button>
          </div>
        </DialogContent>
      )}
    </Dialog>
  );
}
